<template>
  <div class="ds-context-menu-group" :class="[positionX, positionY]" :style="position">
    <template v-for="(menu, index) in realList">
      <div v-if="menu.divided" :key="index" class="ds-context-menu-divided"></div>
      <div
        v-else-if="!contextMenuRoot.isHide(menu)"
        :key="index"
        class="ds-context-menu-item"
        :class="{disabled: contextMenuRoot.isDisabled(menu)}"
        @mouseenter="onMouseenter(menu)"
        @mouseleave="onMouseleave(menu)">
        <div class="ds-context-menu-item-content" :class="{'has-icon': hasIcon}" @click.stop="contextMenuRoot.itemClick(menu, $event)">
          <i v-if="menu.icon" class="ds-context-menu-item-icon iconfont" :class="[menu.icon]" :style="{color: menu.color}"></i>
          <span class="ds-context-menu-item-name">{{ menu.name }}</span>
        </div>
        <i class="item-right" :class="[menu.loading ? 'el-icon-loading' : 'iconfont icon-right']" :show="menu.$hasChildren" />
        <template v-if="menu.$hasChildren && menu.$loaded">
          <dsf-context-menu-group v-if="menu.childrenShow" :list="menu._children" />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DsfContextMenuGroup",
  inject: ['contextMenuRoot'],
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      positionX: 'right',
      positionY: 'bottom',
      top: 0,
      left: 0
    }
  },
  computed: {
    position() {
      let res = {};
      if (this.positionX === 'right' && this.left) {
        res.left = this.left + 'px';
      }
      if (this.positionY === 'bottom' && this.top) {
        res.top = this.top - 5 + 'px';
      }
      return res;
    },
    realList() {
      let res = [], { isHide } = this.contextMenuRoot;
      _.each(this.list, it => {
        if (it.divided) {
          _.last(res)?.divided || res.push(it);
        } else if (!isHide(it)){
          dsf.setObjAttr(it, '$hasChildren', false);
          dsf.setObjAttr(it, '$lazy', false);
          dsf.setObjAttr(it, '$loaded', true);
          if (dsf.isFunction(it.children)) {
            dsf.setObjAttr(it, '$hasChildren', true);
            dsf.setObjAttr(it, '$lazy', true);
            dsf.setObjAttr(it, '$loaded', false);
          } else if (dsf.isArray(it.children) && it.children.length) {
            dsf.setObjAttr(it, '$hasChildren', true);
            dsf.setObjAttr(it, '_children', it.children);
          }
          res.push(it);
        }
      });
      if (_.last(res)?.divided) {
        res.pop();
      }
      return res;
    },
    hasIcon() {
      return !!_.find(this.realList, it => !!it.icon);
    },
  },
  mounted() {
    let { innerWidth, innerHeight } = window;
    let { top, bottom, left, right, width, height } = this.$el.getBoundingClientRect();
    let _left = innerWidth - right - 15;
    let _top = innerHeight - bottom - 15;
    if (right - innerWidth > 0) {
      if (left - width > 0) {
        this.positionX = 'left';
      } else if (_left < 0) {
        if (left + _left < 0) {
          _left = -left;
        }
        this.left = _left;
      }
    }
    if (bottom - innerHeight > 0) {
      if (top - height > 0) {
        this.positionY = 'top';
      } else if (_top < 0) {
        if (top + _top < 0) {
          _top = -top;
        }
        this.top = _top;
      }
    }
  },
  methods: {
    async onMouseenter(menu) {
      if (!menu.$hasChildren) return;
      this.$set(menu, 'childrenShow', true);
      if (menu.$lazy && !menu.$loaded) {
        try {
          this.$set(menu, 'loading', true);
          let res = await menu.children();
          dsf.setObjAttr(menu, '$loaded', true);
          if (dsf.isArray(res) && res.length) {
            dsf.setObjAttr(menu, '_children', res);
          } else {
            dsf.setObjAttr(menu, '$hasChildren', false);
            dsf.setObjAttr(menu, '$lazy', false);
            this.$set(menu, 'loading', false);
            return;
          }
          this.$set(menu, 'loading', false);
        } catch (e) {
          this.$set(menu, 'loading', false);
          throw e;
        }
      }
    },
    onMouseleave(menu) {
      if (!menu.$hasChildren) return;
      this.$set(menu, 'childrenShow', false);
    },
  }
}
</script>